import { groupByEnum } from "kubb";
import type React from "react";
import {
  ButtonGroupField,
  type ButtonGroupFieldProps,
  type Option,
} from "../ButtonGroup";

interface CommonProps extends Omit<ButtonGroupFieldProps, "options"> {
  noneLabel?: string;
  includeLocationGroup?: boolean;
  includeScheme?: boolean;
}

export default function GroupByRadioButtonGroupField(
  props: CommonProps,
): React.ReactElement {
  const { noneLabel, includeLocationGroup, includeScheme, ...rest } = props;
  const options: Option[] = [
    { label: noneLabel || "NONE", value: groupByEnum.NONE },
    includeScheme && { label: " SCHEME", value: groupByEnum.SCHEME },
    includeLocationGroup && { label: "GROUP", value: groupByEnum.GROUP_ALL },
  ].filter((v) => {
    return v !== undefined && v !== false;
  });

  return <ButtonGroupField {...rest} options={options} />;
}
